import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { navigateAction } from 'fluxible-router';
import Select from '../../Select';

const getLanguageId = pathname =>
  pathname
    .split('/')
    .slice()
    .pop()
    .split('-')
    .pop();

class LanguageSelector extends Component {
  options = this.props.languages.map(lang => ({
    label: lang.name,
    value: lang.url
  }));

  handleChange = (e) => {
    const currentLanguageID = getLanguageId(this.props.pathname);
    const selectedLanguageID = e.target.value;
    const url = this.props.pathname.replace(currentLanguageID, selectedLanguageID);

    this.context.executeAction(navigateAction, { url });
  }

  render() {
    return (
      <Select
        options={this.options}
        selected={this.options.findIndex(v => v.value === getLanguageId(this.props.pathname))}
        handleChange={this.handleChange}
        label="Language"
      />
    );
  }
}

LanguageSelector.contextTypes = {
  executeAction: PropTypes.func
};

LanguageSelector.propTypes = {
  languages: PropTypes.array.isRequired,
  pathname: PropTypes.string.isRequired
};

export default LanguageSelector;
